import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AddBrand from '../components/addBrand';
import { saveBrand } from '../actions';
import withNotifications from '../../../common/withNotifications';
import { t } from '../../../../modules/infra/i18n';

const mapDispatchToProps = {
  saveBrand,
};

const AddBrandContainer = compose(
  connect(null, mapDispatchToProps),
  withNotifications,
  withRouter,
  withHandlers({
    onSave: props => brand => props.saveBrand(brand)
      .then((brandId) => {
        props.router.push(`/admin/brands/${brandId}`);
        props.addNotification({
          title: t('brand:add.success_title'),
          level: 'success',
          message: t('brand:add.save_success_message'),
        });
      }),
  }),
)(AddBrand);
export default AddBrandContainer;
